import { render, staticRenderFns } from "./SubscribeTeamPage.vue?vue&type=template&id=5479f341"
import script from "./SubscribeTeamPage.vue?vue&type=script&lang=js"
export * from "./SubscribeTeamPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports